import { Reveal } from "@/components/yanre/Reveal";
import { useLocale } from "@/i18n/LocaleContext";

// SECTION — Monetize Available Studio Hours. No income guarantees, no ROI
// promises — better utilization of unused hours as an additional revenue stream.
export const PTMonetize = () => {
  const { t } = useLocale();
  return (
    <section className="section-darker py-24 lg:py-32" data-testid="pt-monetize-section">
      <div className="container-edge">
        <Reveal>
          <div className="mb-6 flex items-center gap-4">
            <span className="h-px w-10 bg-signal" />
            <span className="overline">{t("pts.monetize.label", "Monetize Available Studio Hours")}</span>
          </div>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="max-w-5xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-white sm:text-6xl" data-testid="pt-monetize-h2">
            {t("pts.monetize.h2a", "Make your studio work")}{" "}
            <span className="text-signal">{t("pts.monetize.h2b", "even when you're not.")}</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-2xl text-base font-light leading-relaxed text-titanium/75 sm:text-lg" data-testid="pt-monetize-copy">
            {t(
              "pts.monetize.copy",
              "Your studio doesn't have to generate value only when you're training your own clients. Available hours can become an additional revenue opportunity by giving other Personal Trainers access to your professional training space."
            )}
          </p>
        </Reveal>

        {/* Visual business model: clients + hours = revenue stream */}
        <div className="mt-14 grid items-stretch gap-4 lg:grid-cols-[1fr_auto_1fr_auto_1fr]" data-testid="pt-monetize-model">
          <Reveal>
            <div className="h-full border border-carbon-600 bg-carbon-900 p-8" data-testid="pt-monetize-clients">
              <p className="font-display text-xl font-bold uppercase tracking-wide text-white sm:text-2xl">
                {t("pts.monetize.clients", "Your Clients")}
              </p>
              <p className="mt-3 text-sm font-light text-titanium/65">
                {t("pts.monetize.clientsSub", "Your own training sessions")}
              </p>
            </div>
          </Reveal>
          <div className="flex items-center justify-center font-display text-4xl font-extrabold text-signal">+</div>
          <Reveal delay={0.08}>
            <div className="h-full border border-carbon-600 bg-carbon-900 p-8" data-testid="pt-monetize-hours">
              <p className="font-display text-xl font-bold uppercase tracking-wide text-white sm:text-2xl">
                {t("pts.monetize.hours", "Available Hours")}
              </p>
              <p className="mt-3 text-sm font-light text-titanium/65">
                {t("pts.monetize.hoursSub", "Other trainers use your studio")}
              </p>
            </div>
          </Reveal>
          <div className="flex items-center justify-center font-display text-4xl font-extrabold text-signal">=</div>
          <Reveal delay={0.16}>
            <div className="h-full border border-signal/60 bg-signal/5 p-8" data-testid="pt-monetize-revenue">
              <p className="font-display text-xl font-bold uppercase tracking-wide text-white sm:text-2xl">
                {t("pts.monetize.revenue", "Another Revenue Stream")}
              </p>
              <p className="mt-3 text-sm font-light text-titanium/65">
                {t("pts.monetize.revenueSub", "Make better use of your space throughout the day")}
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <p className="mt-14 font-display text-3xl font-extrabold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl" data-testid="pt-monetize-closing">
            {t("pts.monetize.closeA", "You own the studio.")}{" "}
            <span className="text-signal">{t("pts.monetize.closeB", "You control the schedule.")}</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
};
